'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImmutableType = exports.IS_ITERABLE_SENTINEL = undefined;
exports.isImmutableList = isImmutableList;
exports.isImmutableMap = isImmutableMap;
exports.isImmutableIterable = isImmutableIterable;

var _ramda = require('ramda');

// copied from immutable project
var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

function isImmutableList(maybeList) {
  return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
}

var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

function isImmutableMap(maybeMap) {
  return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
}

var IS_ITERABLE_SENTINEL = exports.IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';

function isImmutableIterable(maybeCollection) {
  return !!(maybeCollection && maybeCollection[IS_ITERABLE_SENTINEL]);
}

var isImmutableType = exports.isImmutableType = (0, _ramda.anyPass)([isImmutableList, isImmutableMap, isImmutableIterable]);